import { ChevronLeft, ChevronRight } from '@velocity-exchange/icons';
import { NotificationData } from 'src/utils/notifications';

interface Props {
	visibleNotificationIndex: number;
	notifications: NotificationData[];
	handleBack: () => void;
	handleForward: () => void;
}

const PAGINATION_BUTTON_CLASSNAME =
	'flex -m-sm p-sm text-text-secondary hover:text-text-default disabled:opacity-60';

export default function MinorAlertNotificationsPagination({
	visibleNotificationIndex,
	notifications,
	handleBack,
	handleForward,
}: Props) {
	return (
		<div className="flex items-center gap-x-xs">
			<button
				onClick={handleBack}
				disabled={visibleNotificationIndex === 0}
				className={PAGINATION_BUTTON_CLASSNAME}
			>
				<ChevronLeft size={16} />
			</button>
			<span className="typo-label-xs">
				<span className="text-text-default">
					{visibleNotificationIndex + 1}
				</span>
				<span className="text-text-secondary">/{notifications.length}</span>
			</span>
			<button
				onClick={handleForward}
				disabled={visibleNotificationIndex === notifications.length - 1}
				className={PAGINATION_BUTTON_CLASSNAME}
			>
				<ChevronRight size={16} />
			</button>
		</div>
	);
}
